import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import logo from "../assets/images/logo.png";
export default function LogoBig() {
    return (_jsx("img", { src: logo, style: { height: 54, marginBottom: 25 }, alt: "apomap-logo" }));
}
